import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getStepIndicatorStyle, getStepProgressBarStyle } from '../styles/step-progress-bar-styles';

function StepIndicator(props) {
  const {
    index,
    title,
    isCurrentStep,
  } = props;

  const classes = useDefaultStyles(getStepIndicatorStyle);

  return (
    <div
      className={classNames(classes.stepIndicator, 'step-indicator', isCurrentStep && classes.currentStep)}
    >
      <span className={classNames(classes.stepIndicatorIndex, 'step-indicator-index')}>
        {index}
      </span>
      <span className={classNames(classes.stepIndicatorTitle, 'step-indicator-title')}>
        {title}
      </span>
    </div>
  );
}

StepIndicator.propTypes = {
  index: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  isCurrentStep: PropTypes.bool.isRequired,
};

export const StepProgressBar = (props) => {
  const {
    steps,
  } = props;
  const classes = useDefaultStyles(getStepProgressBarStyle);

  return (
    <div className={classNames(classes.stepProgressBar, 'step-progress-bar')}>
      {_.map(steps, (step, index) => (
        <StepIndicator
          index={index + 1}
          key={step.title}
          title={step.title}
          isCurrentStep={step.isCurrentStep}
        />
      ))}
    </div>
  );
};

StepProgressBar.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    isCurrentStep: PropTypes.bool.isRequired,
  })).isRequired,
};
